import DiningRoundedIcon from '@mui/icons-material/DiningRounded';
import RestaurantMenuRoundedIcon from '@mui/icons-material/RestaurantMenuRounded';
import PaymentsIcon from '@mui/icons-material/Payments';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import StoreIcon from '@mui/icons-material/Store';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import InventoryIcon from '@mui/icons-material/Inventory';

const OnboardingConfig = [
  {
    type: 'restaurant',
    title: 'Restaurant',
    description: 'Setup for dine-in and quick-service restaurant.',
    icon: DiningRoundedIcon,
    order_type: [
      {
        type: 'fine_dining',
        title: 'Fine Dining',
        description: 'For full-service restaurants with table orders',
        icon: RestaurantMenuRoundedIcon,
      },
      {
        type: 'pre_paid',
        title: 'Pre-paid',
        description: 'Ideal quick service setups with upfront payment',
        icon: PaymentsIcon,
      },
      {
        type: 'other',
        title: 'Other',
        description: 'Custom setup for cage, takeaway and special format',
        icon: DashboardRoundedIcon,
      },
    ],
  },
  {
    type: 'supermarket',
    title: 'Supermarket',
    description: 'Setup for grocery and retail businesses.',
    icon: ShoppingBasketIcon,
    order_type: [
      {
        type: 'mini_mart',
        title: 'Mini mart',
        description: 'Best for grocery and convenience store setups',
        icon: StoreIcon,
      },
      {
        type: 'delivery',
        title: 'Delivery',
        description: 'Perfect for businesses offering doorstep services',
        icon: DeliveryDiningIcon,
      },
      {
        type: 'other',
        title: 'Other',
        description: 'Flexible setup for any unique business type',
        icon: DashboardRoundedIcon,
      },
    ],
  },
  {
    type: 'other',
    title: 'Other',
    description: 'Custom setup for any business type.',
    icon: DashboardRoundedIcon,
    order_type: [
      {
        type: 'take_away',
        title: 'Take away',
        description: 'Order online and pick up at your convenience.',
        icon: InventoryIcon,
      },
      {
        type: 'delivery',
        title: 'Delivery',
        description: 'Get your food delivered right to your door.',
        icon: DeliveryDiningIcon,
      },
      {
        type: 'other',
        title: 'Other',
        description: 'Choose for dine-in or custom service options.',
        icon: DashboardRoundedIcon,
      },
    ],
  },
];

export default OnboardingConfig;
